module.exports = __webpack_public_path__ + "static/img/NSW-32.9031b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-32.jpg
// module id = PGLL
// module chunks = 0